
export function fieldName( obj, field )
{
    for ( const name in obj )
    {
        if ( obj[ name ] === field ) return name;
    }
}

export function Image( name )
{
    const texture = PIXI.utils.TextureCache[ name ]
    if ( ! texture ) throw "no texture " + name
    return new PIXI.Sprite( texture )
}




// WEBPACK FOOTER //
// ./src/library/utils.es6